import React, { Component, useEffect, useState } from "react";
import { getCurrentUser } from "../../../services/authService";
import config from "../../../config.json";
import { v4 as uuidv4 } from "uuid";
import WorkflowElement from "../../../app/components/WorkflowElement";
import { getAppDefaultData, getStartedAppData, loadAppDefaultData, startNewApplication } from "../../../app/store/application";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewRecruiter, addNewRecruiterUser, getNewRecruiterId,
  getNewRecruiterUser, getRecruiterBprmForm, loadRecruiterBprmForm, recruiterAdded, recruiterUserAdded, sendMailToRecruiter
} from "../../../app/store/recruiter";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import { currentWfTaskReceived, getCurrentWorkflowTask, loadCurrentWorkflowTask } from "../../../app/store/WorkflowEngine";
import { addFormLibrary } from "../../../app/store/forms";
import {
  checkedSubEmail, checkedSubUsrEmail, checkedSubUsrMobile, checkSubcontractorEmail,
  checkSubcontractorUsrEmail, checkSubcontractorUsrMobile, getCheckSubEmailStatus,
  getCheckSubUsrEmailStatus, getCheckSubUsrMobileStatus, subcontractorUserRefresh
} from "../../../app/store/subcontractor";
import { updateBprmForm } from "../../../app/store/bprmForm";
import _ from "lodash";
import { loadRecruiterPartners, recruiterPartnersRecevied } from "../../../app/store/partner";

const EditPartner = (props) => {
  const { selectedObj, handleAddEditRecruiter, selectedTab, hideHeader, viewOnly } = props;
  const [wfTask, setWfTask] = useState(null);
  const [appDefaultData, setAppDefaultData] = useState("");
  const [stateData, setStateData] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [updatedStateData2, setUpdatedStateData2] = useState(null);
  const [saveBtnProcessStatus, setSaveBtnProcessStatus] = useState(false);
  const [uuid, setUuid] = useState("");
  const [wfId, setWfId] = useState(config.workflowsIds.recruiter);
  const [reqCount, setReqCount] = useState(0);
  const [newRecruiterAddedStatus, setNewRecruiterAddedStatus] = useState(false);
  const [wfForm, setWfForm] = useState(null);
  const [saveBtnType, setSaveBtnType] = useState("");
  const [dupliEntry, setDupliEntry] = useState("");
  const [addedParterId, setAddedParterId] = useState(0);
  const [addedParterUserId, setAddedParterUserId] = useState(0);
  const [hasChanges, setHasChanges] = useState(false);

  const appDefaultDataSelector = useSelector(getAppDefaultData);
  const newRecruiterIdSelector = useSelector(getNewRecruiterId)
  const newRecruiterUserSelector = useSelector(getNewRecruiterUser);
  const appStartedDataSelector = useSelector(getStartedAppData);
  const currentWorkflowTaskSelector = useSelector(getCurrentWorkflowTask);
  const checkSubEmailStatusSelector = useSelector(getCheckSubEmailStatus);
  const checkSubUsrEmailStatusSelector = useSelector(getCheckSubUsrEmailStatus);
  const checkSubUsrMobileStatusSelector = useSelector(getCheckSubUsrMobileStatus);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedTab === "addEditRecruiter")
      dispatch(loadAppDefaultData(1))
  }, []);

  useEffect(() => {
    if (selectedTab === "addEditRecruiter") {
      let appCiid = 0;
      if (selectedObj?.applications?.length > 0) {
        appCiid = selectedObj?.applications[0].ciid;
      }
      setWfTask({ formId: config.formIds.recruiter, ciid: appCiid });
      dispatch(loadRecruiterBprmForm(config.formIds.recruiter))
      setSaveBtnProcessStatus(false)
    }
  }, [selectedObj, selectedTab]);

  useEffect(() => {
    if (recruiterBprmFormSelector) setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector])

  useEffect(() => {
    if (appDefaultDataSelector !== "") {
      setAppDefaultData(appDefaultDataSelector);
    }
  }, [appDefaultDataSelector]);

  const handleSubmit = (stData) => {
    const aWorkfinityApp = { ...appDefaultData };
    const appShortName = Object.keys(aWorkfinityApp)[1];
    let aWorkfinityAppEntity = { ...aWorkfinityApp[appShortName] };
    let recruiterenrollment = {};
    const data = {};
    Object.keys(stData).forEach(function (keyValue) {
      const dd = keyValue.split(".");
      if (dd.length > 1) {
        if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
          recruiterenrollment["@" + dd[1]] = stData[keyValue];
        data[dd[1]] = stData[keyValue];
      }
    });

    const guid = uuidv4();
    const jhgf = JSON.parse(updatedStateData);
    const entiyId = jhgf?.HROCCMSAppEntity?.recruiterenrollmentform?.EntityId;

    if (!selectedObj || selectedObj === "") {
      if (addedParterUserId <= 0) {
        recruiterenrollment["EntityId"] = guid;
        data["EntityId"] = guid;
      } else {
        const jhgfss = JSON.parse(updatedStateData2);
        const entiyId2 = jhgfss?.HROCCMSAppEntity?.recruiterenrollmentform?.EntityId;
        recruiterenrollment["EntityId"] = entiyId2;
        data["EntityId"] = entiyId2;
      }
    } else {
      recruiterenrollment["EntityId"] = entiyId;
      data["EntityId"] = entiyId;
    }

    const usrDdtype = "recruiterenrollmentform";
    aWorkfinityAppEntity[usrDdtype] = recruiterenrollment;
    aWorkfinityApp[appShortName] = aWorkfinityAppEntity;

    setStateData(data);
    setUuid(guid)
    setAppDefaultData(aWorkfinityApp);

    if (!selectedObj || selectedObj === "") {
      if (addedParterId <= 0) {
        const partEmail = data["Company_Email"];
        const keyEmail = data["Key_Contact1_Email"];
        const keyMobile = data["Key_Contact1_Mobile"];
        if (partEmail && partEmail !== "") {
          dispatch(checkSubcontractorEmail(partEmail, "Recruiter"));
        } else if (keyEmail && keyEmail !== "") {
          dispatch(checkSubcontractorUsrEmail(keyEmail, "Recruiter"));
        } else if (keyMobile && keyMobile !== "") {
          dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
        } else {
          saveRecruiter(data);
        }
      } else {
        saveRecruiter(data);
      }
    }
    else {
      saveRecruiter(data);
    }
  }

  useEffect(() => {
    const keyEmail = stateData ? stateData["Key_Contact1_Email"] : "";
    const keyMobile = stateData ? stateData["Key_Contact1_Mobile"] : "";
    if (checkSubEmailStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Recruiter Email alreday exist. Do you want Add duplicate Email Address?", "warning");
        if (rs.isConfirmed) {
          if (keyEmail && keyEmail !== "") {
            dispatch(checkSubcontractorUsrEmail(keyEmail, "Recruiter"));
          } else if (keyMobile && keyMobile !== "") {
            dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
          }
          else {
            saveRecruiter(stateData);
          }
        }
        else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubEmailStatusSelector === false) {
      if (keyEmail && keyEmail !== "") {
        dispatch(checkSubcontractorUsrEmail(keyEmail, "Recruiter"));
      } else if (keyMobile && keyMobile !== "") {
        dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
      }
      else {
        saveRecruiter(stateData);
      }
    }
  }, [checkSubEmailStatusSelector]);

  useEffect(() => {
    const keyMobile = stateData ? stateData["Key_Contact1_Mobile"] : "";

    if (checkSubUsrEmailStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Recruiter key contact Email alreday exist. Do you want Add duplicate Email Address?", "warning");
        if (rs.isConfirmed) {
          if (keyMobile && keyMobile !== "") {
            dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"))
          }
          else {
            saveRecruiter(stateData);
          }
        } else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubUsrEmailStatusSelector === false) {
      if (keyMobile && keyMobile !== "") {
        dispatch(checkSubcontractorUsrMobile(keyMobile, "Recruiter"));
      }
      else {
        saveRecruiter(stateData);
      }
    }
  }, [checkSubUsrEmailStatusSelector]);

  useEffect(() => {
    if (checkSubUsrMobileStatusSelector) {
      async function userConfirmation() {
        const rs = await getConfirmAlert("Warning", "Recruiter key contact Mobile Number alreday exist. Do you want Add duplicate Mobile Number?", "warning");
        if (rs.isConfirmed) {
          saveRecruiter(stateData);
        } else {
          setSaveBtnProcessStatus(false);
          dispatch(subcontractorUserRefresh())
        }
      }
      userConfirmation();
    }
    else if (checkSubUsrMobileStatusSelector === false) {
      saveRecruiter(stateData);
    }
  }, [checkSubUsrMobileStatusSelector]);

  const saveRecruiter = (data) => {
    if (!data) return;

    const fuid =
      selectedObj?.fuid ??
      (addedParterId > 0 ? addedParterId : 0);

    const getValue = (field) => (data[field] || "").trim();

    const contactName = [
      "Key_Contact1_First_Name",
      "Key_Contact1_Middle_Name",
      "Key_Contact1_Last_Name",
    ]
      .map((field) => getValue(field))
      .filter(Boolean)
      .join(" ");

    const partnerObj = {
      fuid,
      label: getValue("Company_Name"),
      state: getValue("Company_State"),
      city: getValue("Company_City"),
      zip: getValue("Company_Zip_Code"),
      partnerType: "Recruiter",
      contactName,
      entryStartNumber: 1,
      entryEndNumber: 100,
      totalEntryRecords: 100,
      email: getValue("Company_Email"),
      accessKey: getValue("Company_Address_Line1"),
      portalUrl: getValue("Company_Address_Line2"),
    };

    dispatch(addNewRecruiter(partnerObj));
  };

  useEffect(() => {
    if (newRecruiterIdSelector > 0) {
      if (newRecruiterIdSelector === -1) {
        getAlert("Warning", "Email already exists", "error");
        setSaveBtnProcessStatus(false);
      }
      else {
        saveRecruiterUser(newRecruiterIdSelector);
        if (addedParterId === 0 && !selectedObj) {
          dispatch(sendMailToRecruiter(newRecruiterIdSelector))
        }
        setAddedParterId(newRecruiterIdSelector);
      }
    }
  }, [newRecruiterIdSelector]);

  const saveRecruiterUser = (partId) => {
    if (!stateData) return;

    const data = { ...stateData };

    // Determine recruiter user ID
    const regId = selectedObj?.id ?? (addedParterUserId > 0 ? addedParterUserId : 0);

    // Helper to safely extract trimmed values
    const get = (field) => (data[field] || "").trim();

    const reg = {
      id: regId,
      first_Name: get("Key_Contact1_First_Name"),
      middle_Name: get("Key_Contact1_Middle_Name"),
      last_Name: get("Key_Contact1_Last_Name"),
      email: get("Key_Contact1_Email"),
      mobile: get("Key_Contact1_Mobile"),

      workflowId: wfId,
      entityId: uuid,

      // Hard-coded security question (might want dynamic later)
      question: "3151",
      answer: "Miami",

      type: "recruiter",

      // Address fields
      address_Line1: get("Company_Address_Line1"),
      address_Line2: get("Company_Address_Line2"),
      us_State: get("Company_State"),
      us_County: get("Company_County"),
      us_City: get("Company_City"),
      zip_Code: get("Company_Zip_Code"),

      title: get("Key_Contact1_Title"),
      isTeamLead: true,
      partnerId: partId,
    };

    const aWorkfinityApp = { ...appDefaultData };

    // Build FormData payload
    const formData = new FormData();
    formData.append("appEntity", JSON.stringify(aWorkfinityApp));
    formData.append("registration", JSON.stringify(reg));

    dispatch(addNewRecruiterUser(formData));
    setSaveBtnProcessStatus(true);
  };

  const updateBprmFormData = async (aWorkfinityApp) => {
    const disValus = _.uniq(["recruiterenrollmentform"]);
    const frmData = new FormData();
    frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
    frmData.append("ciid", wfTask.ciid);
    frmData.append("ddTypes", disValus);
    frmData.append("formId", wfTask.formId);
    frmData.append("performerId", currentUser.id);
    frmData.append("userName", currentUser.name);
    dispatch(updateBprmForm(frmData));
  };

  useEffect(() => {
    if (newRecruiterUserSelector) {
      setSaveBtnProcessStatus(false);
      setHasChanges(true);
      let regId = 0;
      if (selectedObj?.id) {
        regId = selectedObj?.id;
      } else if (addedParterUserId > 0) {
        regId = addedParterUserId;
      }

      if (newRecruiterUserSelector.performerid === -1) {
        getAlert("Warning", newRecruiterUserSelector.performername, "error");
        setSaveBtnProcessStatus(false);
        handleAddEditRecruiter("exit");
      }
      else {
        if (regId > 0) {
          getAlert("", "Updated Successfully", "success");
          setNewRecruiterAddedStatus(false);

          if (wfTask.ciid > 0)
            updateBprmFormData(appDefaultData);

          if (saveBtnType === "saveAndContinue") {
            dispatch(checkedSubEmail(null))
            dispatch(checkedSubUsrEmail(null))
            dispatch(checkedSubUsrMobile(null))
            handleAddEditRecruiter("exit", true);
          }
        } else {
          getAlert("", "Added Successfully", "success");
          if (saveBtnType === "saveAndContinue") {
            dispatch(checkedSubEmail(null))
            dispatch(checkedSubUsrEmail(null))
            dispatch(checkedSubUsrMobile(null))
            handleAddEditRecruiter("exit", true);
          }
          dispatch(recruiterPartnersRecevied([]));
          dispatch(loadRecruiterPartners("Recruiter"));
          setAddedParterUserId(newRecruiterUserSelector.performerid);
          handleRunApplication(newRecruiterUserSelector);
        }
      }
      dispatch(recruiterAdded(0))
      dispatch(recruiterUserAdded(null))
    }
  }, [newRecruiterUserSelector]);

  const handleRunApplication = async (userObj) => {
    const newApplication = {
      workflowId: userObj.workflowId,
      performerId: parseInt(userObj.performerid),
      applicationId: userObj.applicationId,
    };
    dispatch(startNewApplication(newApplication));
    setNewRecruiterAddedStatus(true);
  };

  useEffect(() => {
    if (appStartedDataSelector?.ciid > 0) {
      setTimeout(async () => {
        dispatch(loadCurrentWorkflowTask(appStartedDataSelector));
        setReqCount(1);
      }, 3000);
    }
  }, [appStartedDataSelector]);

  useEffect(() => {
    if (currentWorkflowTaskSelector?.formId === null && reqCount <= 2 && newRecruiterAddedStatus) {
      setTimeout(async () => {
        dispatch(loadCurrentWorkflowTask(appStartedDataSelector));
        const rqCount = reqCount + 1;
        setReqCount(rqCount)
      }, 3000);
    }
    else if (currentWorkflowTaskSelector?.wiid > 0 && newRecruiterAddedStatus) {
      setNewRecruiterAddedStatus(false);
      dispatch(currentWfTaskReceived(""));
      setWfTask(currentWorkflowTaskSelector);
    }
  }, [currentWorkflowTaskSelector]);

  useEffect(() => {
    if (selectedObj?.contact1) {
      setUpdatedStateData(selectedObj.contact1.performerData)
    }
    else {
      setUpdatedStateData(null);
    }
  }, [selectedObj]);

  useEffect(() => {
    if (dupliEntry?.contact1) {
      setUpdatedStateData2(dupliEntry.contact1.performerData)
    }
    else {
      setUpdatedStateData2(null);
    }
  }, [dupliEntry]);

  const handleNextTask = (data, btn) => {
    handleSubmit(data);
    if (btn) setSaveBtnType(btn)
  }

  return (
    <div className="col-md-12 px-0">
      <div className="as-card">
        <style>{`
          @keyframes asFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          .as-card {
            border: 1px solid rgba(226, 232, 240, 0.9) !important;
            border-radius: 20px !important;
            background: #ffffff !important;
            box-shadow: 0 18px 45px rgba(15, 23, 42, 0.07) !important;
            margin-top: 10px !important;
            animation: asFadeIn 0.3s ease both !important;
            overflow: hidden !important;
          }

          /* ── Form Header ── */
          .as-form-header {
            display: flex !important;
            align-items: flex-start !important;
            justify-content: space-between !important;
            flex-wrap: wrap !important;
            gap: 18px !important;
            padding: 22px 24px 18px !important;
            background: #ffffff !important;
            border-bottom: 1px solid #d1d5db !important;
            position: relative !important;
            overflow: hidden !important;
          }
          .as-form-header-left {
            display: flex !important;
            align-items: flex-start !important;
            gap: 14px !important;
            min-width: 260px !important;
            flex: 1 1 360px !important;
          }
          .as-form-header-right {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            justify-content: flex-end !important;
            margin-left: auto !important;
            position: relative !important;
            z-index: 1 !important;
            flex-shrink: 0 !important;
          }
          .as-header-back-btn {
            background: #ffffff !important;
            border: 1px solid #d1d5db !important;
            border-radius: 8px !important;
            padding: 6px 14px !important;
            color: #404040 !important;
            font-size: 12.5px !important;
            font-weight: normal !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            box-shadow: none !important;
            outline: none !important;
            height: 34px !important;
          }
          .as-header-back-btn:hover {
            background: #f5f5f5 !important;
            border-color: #a3a3a3 !important;
            color: #171717 !important;
            transform: none !important;
          }
          .as-form-header-icon {
            width: 44px !important;
            height: 44px !important;
            border-radius: 12px !important;
            background: #f3f4f6 !important;
            border: 1px solid #d1d5db !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: #525252 !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
            box-shadow: none !important;
          }
          .as-form-header-text {
            position: relative !important;
            z-index: 1 !important;
          }
          .as-form-header-title {
            color: #171717 !important;
            font-size: 16px !important;
            font-weight: 600 !important;
            margin: 0 !important;
            line-height: 1.2 !important;
          }
          .as-form-header-sub {
            color: #64748b !important;
            font-size: 13px !important;
            margin-top: 6px !important;
            font-weight: 600 !important;
            max-width: 620px !important;
          }
          .as-form-header-meta {
            display: flex !important;
            align-items: center !important;
            gap: 7px !important;
            flex-wrap: wrap !important;
            margin-top: 10px !important;
          }
          .as-meta-pill {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            padding: 4px 12px !important;
            border-radius: 99px !important;
            background: #ffffff !important;
            border: 1px solid #d1d5db !important;
            color: #404040 !important;
            font-size: 12px !important;
            font-weight: normal !important;
            height: auto !important;
            line-height: 1.5 !important;
          }

          /* ── Form Body ── */
          .as-form-body {
            padding: 24px !important;
            background: #f8fafc !important;
            border-bottom: 1.5px solid #f1f5f9 !important;
          }

          .as-meta-pill i {
            color: #94a3b8 !important;
          }

          .as-card .as-form-body .form-control-label {
            color: #404040 !important;
            font-size: 12px !important;
            font-weight: 500 !important;
          }

          .as-card .as-form-body .form-control-label > i.fa,
          .as-card .as-form-body .wf-input-icon {
            display: none !important;
          }

          .as-card .as-form-body .wf-input-wrap > .form-control,
          .as-card .as-form-body .wf-input-wrap .d-flex > .form-control {
            min-height: 40px !important;
            padding: 9px 12px !important;
            background: #ffffff !important;
            border: 1px solid #d1d5db !important;
            border-radius: 8px !important;
            color: #171717 !important;
            font-size: 13px !important;
            font-weight: normal !important;
            box-shadow: none !important;
          }

          .as-card .as-form-body .wf-input-wrap > .form-control:focus,
          .as-card .as-form-body .wf-input-wrap .d-flex > .form-control:focus {
            border-color: #737373 !important;
            box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06) !important;
          }

          /* ── Form Footer ── */
          .as-form-footer {
            display: flex !important;
            align-items: center !important;
            justify-content: flex-end !important;
            gap: 10px !important;
            flex-wrap: wrap !important;
            padding: 14px 22px !important;
            border-top: 1.5px solid #f1f5f9 !important;
            background: #fafbfd !important;
          }
        `}</style>

        {/* ── Form Header ── */}
        {hideHeader !== true && (
          <div className="as-form-header">
            <div className="as-form-header-left">
              <div className="as-form-header-icon">
                <i
                  className={`fa ${selectedObj ? "fa-pencil-square-o" : "fa-handshake-o"}`}
                />
              </div>
              <div className="as-form-header-text">
                <p className="as-form-header-title">
                  {selectedObj
                    ? "Edit Recruiter Details"
                    : "Add New Recruiter Partner"}
                </p>
                <div className="as-form-header-meta">
                  <span className="as-meta-pill">
                    <i className="fa fa-id-badge" /> ID: {selectedObj?.fuid || "New"}
                  </span>
                  {selectedObj?.label && (
                    <span className="as-meta-pill">
                      <i className="fa fa-user" /> {selectedObj.label}
                    </span>
                  )}
                  {selectedObj?.email && (
                    <span className="as-meta-pill">
                      <i className="fa fa-envelope-o" /> {selectedObj.email}
                    </span>
                  )}
                  <span className="as-meta-pill">
                    <i className="fa fa-info-circle" /> Status: {
                      selectedObj
                        ? (selectedObj.contact1?.isActive === true
                          ? "Active"
                          : selectedObj.contact1?.isActive === false
                            ? "Inactive"
                            : "Pending Activation")
                        : "New Partner"
                    }
                  </span>
                  {wfTask?.ciid > 0 && (
                    <span className="as-meta-pill">
                      <i className="fa fa-hashtag" /> CIID {wfTask.ciid}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="as-form-header-right">
              {typeof handleAddEditRecruiter === "function" && (
                <button
                  type="button"
                  className="as-header-back-btn"
                  onClick={() => handleAddEditRecruiter("exit", hasChanges)}
                >
                  <i className="fa fa-arrow-left" aria-hidden="true" />
                  Back
                </button>
              )}
            </div>
          </div>
        )}

        {/* ── Form Body ── */}
        <div className="as-form-body">
          <div className="row p-3">
            {wfForm && (
              <WorkflowElement
                wfTask={wfTask}
                wfForm={wfForm}
                handleNextTask={handleNextTask}
                viewType={viewOnly || false}
                appSummary={false}
                codeVerified={selectedObj?.contact1?.performerid ? false : true}
                wfTaskType={"form"}
                actionType={"workflow"}
                saveBtnProcessStatus={saveBtnProcessStatus}
                setSaveBtnProcessStatus={setSaveBtnProcessStatus}
                updatedStateData={updatedStateData}
              />
            )}
          </div>
        </div>

        {/* ── Form Footer ── */}
        <div className="as-form-footer">
          <button
            type="button"
            className="btn-action-search"
            onClick={() => handleAddEditRecruiter("exit", hasChanges)}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPartner;
